module.exports = __webpack_public_path__ + "static/img/shou-sheng-qian.e8c9345.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/shou-sheng-qian.jpeg
// module id = llnJ
// module chunks = 1